module.exports = __webpack_public_path__ + "img/trends_8.15ea9e40.jpg";